/**
 * Entrada suave ao rolar: elementos marcados com [data-animate] nascem discretos (um pouco
 * abaixo e transparentes) e aparecem ao entrar na tela, igual ao efeito das seções da Renova Be.
 * Sem JavaScript, ou para quem prefere menos movimento, tudo já aparece normal (ver base.css).
 *
 * Conteúdo carregado depois (ex.: recomendações de produto buscadas por fetch) não é pego
 * automaticamente porque o observador só varre a página uma vez. Nesses casos, o script que
 * injeta o conteúdo novo deve chamar window.themeReveal.observe(elementoOuLista).
 */
(() => {
  if (window.themeReveal) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsObserver = 'IntersectionObserver' in window;

  const showImmediately = (elements) => elements.forEach((el) => el.classList.add('is-visible'));

  let observer = null;
  if (supportsObserver && !prefersReducedMotion) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
  }

  const observe = (target) => {
    const elements = target instanceof Element ? [target] : Array.from(target || []);
    if (!elements.length) return;
    if (observer) elements.forEach((el) => observer.observe(el));
    else showImmediately(elements);
  };

  observe(document.querySelectorAll('[data-animate]'));

  // Editor de temas: a seção adicionada ou editada é redesenhada do zero; sem isto os elementos
  // dela ficariam invisíveis (opacity 0) até salvar e recarregar a página.
  document.addEventListener('shopify:section:load', (event) => {
    const fresh = event.target.querySelectorAll('[data-animate]');
    if (window.Shopify && window.Shopify.designMode) showImmediately(Array.from(fresh));
    else observe(fresh);
  });

  window.themeReveal = { observe };
})();
